import { makeAutoObservable } from 'mobx';
import EnrollmentPeriodModule from 'store/modules/enrollment/enrollmentPeriodModule';
import GroupModule from 'store/modules/group/groupModule';

interface InfoBlobData {
  groupName: string;
  effectiveDate: string;
}

export class EnrollmentGroupInfoDelegate {
  private _groupModule: GroupModule;
  private _enrollmentPeriodModule: EnrollmentPeriodModule;

  public get infoBlobData(): InfoBlobData | null {
    if (this.isFlowDataLoading) return null;
    return {
      groupName: this._groupModule.group.name,
      effectiveDate: this._enrollmentPeriodModule.enrollmentPeriod?.effectiveDate || '',
    };
  }

  public get isFlowDataLoading(): boolean {
    return this._groupModule.isLoading || this._enrollmentPeriodModule.isLoading;
  }

  constructor(groupModule: GroupModule, enrollmentPeriodModule: EnrollmentPeriodModule) {
    this._groupModule = groupModule;
    this._enrollmentPeriodModule = enrollmentPeriodModule;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
